import axios from "@/lib/axios";
import { SpringPage, SpringPageableRequest } from "@/types/apis";
import { UserRole } from "@/types/user";

type GetUsersByCompanyIdRequestParams = SpringPageableRequest & {
  companyId: string;
  q: string;
};

export type GetUsersByCompanyIdResponseContent = {
  id: string;
  name: string;
  email: string;
  companyId: string;
  role: UserRole;
};

type GetUsersByCompanyIdResponse =
  SpringPage<GetUsersByCompanyIdResponseContent>;

export const getUsersByCompanyId = (params: GetUsersByCompanyIdRequestParams) =>
  axios
    .get<GetUsersByCompanyIdResponse>(`/v1/companies/${params.companyId}/users`)
    .then((res) => res.data);
